import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Countdown } from "../components/Countdown";
import { OurStory } from "../components/OurStory";
import { Details } from "../components/Details";
import { Rsvp } from "../components/Rsvp";
import { Gallery } from "../components/Gallery";
import { Footer } from "../components/Footer";

export default function WeddingSite() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="wedding-site" className="bg-cream text-ink overflow-x-clip">
      <Navbar />
      <Hero />
      <Marquee />
      <Countdown />
      <OurStory />
      <Details />
      <Rsvp />
      <Gallery />
      <Footer />
    </div>
  );
}
